<template>
    <b-modal
    id="disable-auth-modal"
    :visible="value"
    @change="updateValue"
    @hide="closeModal"
    hide-footer
    centered
    size="md"
    >
    <h5 class="mb-1 text-center">{{ modalData.title }}</h5>
    <div class="col-24 text-center">
      <label class="mb-4">
          {{ modalData.description }}
      </label>
    </div>
    <div v-show="credentialsError"  class="alert alert-warning text-center">
          <span v-text="$ml.get('tryAgain')"
            >Por favor, revise os dados fornecidos e tente
            novamente.</span
          >
    </div>
 
    <div class="col-24 d-flex justify-content-center">
      <div class="form-group col-16">
        <label class="text-muted" v-text="$ml.get('useCodeEmail')"
          >Use o código recebido por email</label
        >
        <the-mask
          class="form-control"
          v-model="codeEmail"
          :mask="['### ###']"
          @input="updateCodeEmail" 
          :placeholder="$ml.get('enterTheCode')"
        />
        <div
          class="col-24"
          :style="[
            { display: errorCodeEmail ? 'flex' : '' },
            {
              'justify-content': errorCodeEmail ? 'space-between' : '',
            },
          ]"
        >
          <transition name="fade">
            <label
              v-if="errorCodeEmail"
              style="position: relative; !important"
              class="lblError"
              v-text="$ml.get('invalidCodeError')"
            >
              O código informado não é válido!
            </label>
          </transition>
          <label
            style="color: #730ba9; cursor: pointer; font-size: 12px; white-space: nowrap;"
            @click="sendCodeEmail"
            >{{
              timeLeftEmail > 0
                ? `${$ml.get("requestNewCodeEmail")} ${formattedTimeEmail}`
                : $ml.get("receiveCode")
            }}</label
          >
        </div>
      </div>
    </div>
    <div v-if="this.modalData.type === '2fa'" class="d-flex justify-content-center">
      <div class="form-group col-16">
        <label class="text-muted">{{labelCredentials}}</label>
        <the-mask
            class="form-control"
            v-model="codeInput"
            :mask="['### ###']"
            placeholder="999 999"
            @input="updateCodeInput" />
      </div>
    </div>
    <div v-else class="d-flex justify-content-center">
      <div class="form-group col-16">
        <label class="text-muted">{{labelCredentials}}</label>
        <input
          v-model="codeInput"
          autocapitalize="off"
          class="form-control"
          :placeholder="inputPlaceholder"
          :type="inputType"
          @input="updateCodeInput" />
      </div>
    </div>
    <div class="d-flex justify-content-center">
        <RecaptchaV2 ref="recaptcha" @verify="setRecaptchaToken" @expired="tokenRecaptcha = ''" />
    </div>

    <div class="swal2-actions">
        <button type="button" class="swal2-confirm swal2-styled btn" @click="disableAuth" :disabled="!tokenRecaptcha || !codeEmail || !codeInput">
        {{ modalData.type === 'tokenBackup' ? $ml.get("toCheck") : $ml.get("remove") }}
        </button>
        <button type="button" class="swal2-cancel swal2-styled" @click="closeModal">
        {{ $ml.get("cancel") }}
        </button>
    </div>
    </b-modal>
  </template>
  
  <script>
  import Swal from "sweetalert2";
import RecaptchaV2 from '../../components/recaptchaV2.vue';
import AccountService from "../../services/account.service";
import lockerService from '../../services/locker.service';
  export default {
    components: {
      RecaptchaV2,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      modalData: {
        type: Object,
        required: true
      }
    },
    data() {
        return {
            codeInput: '',
            tokenRecaptcha: "",

            codeEmail:"",
            errorCodeEmail:false,
            formattedTimeEmail:"",
            timeLeftEmail: 0,
            credentialsError:false,
        }
    },
    watch: {
      value(newVal) {
        if (newVal) {
          this.codeInput = '';
        }
      },
      credentialsError(){
        if(this.credentialsError){
          this.$refs.recaptcha.resetRecaptcha();
        }
      }
    },
    methods: {
      async sendCodeEmail() {
      if (this.timeLeftEmail > 0) return;

      const newCodeRequest = 300;
      this.timeLeftEmail = newCodeRequest;

      const interval = setInterval(() => {
        if (this.timeLeftEmail > 0) {
          this.timeLeftEmail--;

          const minutes = Math.floor(this.timeLeftEmail / 60);
          const seconds = this.timeLeftEmail % 60;

          this.formattedTimeEmail = `${minutes}:${seconds
            .toString()
            .padStart(2, "0")}`;
        } else {
          clearInterval(interval);
        }
      }, 1000);

      try {
        const { status } = await this.modalData.type === '2fa_locker' ? lockerService.getTokenEmailLocker() :  AccountService.getTokenEmail();

        if (status === 200) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("sendToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        console.log(error.response);
        if (
          error.response.data.message ===
          "Aguarde 5 minutos para receber outro token"
        ) {
          Swal.fire({
            icon: "warning",
            title: this.$ml.get("waitToRequestNewToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      }
    },

      closeModal() {
        this.$emit('input', false);
        this.tokenRecaptcha = "";
        this.codeEmail = "";
        this.credentialsError = false;
        this.timeLeftEmail = 0;
      },
      updateValue(val) {
        this.$emit('input', val);
      },
      setRecaptchaToken(token) {
        this.$emit('update:setRecaptchaToken', token)
        this.tokenRecaptcha = token;
      },
      updateCodeInput() {
        this.$emit('update:codeInput', this.codeInput)
      },
      disableAuth() {
        this.$emit('disableAuth', this.modalData.type)
      },
      updateCodeEmail(){
        this.$emit('update:codeEmail', this.codeEmail)
      }
    },
    computed: {
      labelCredentials() { return this.modalData.type === 'phone' ? this.$ml.get('confirmPasswordLabel') : this.$ml.get('enterTheCode2fa')},
      inputPlaceholder() { return this.modalData.type === 'phone' ? "*********" : this.$ml.get('enterTheCode')},
      inputType() { return this.modalData.type === 'phone' ? 'password' : 'text' }
    },
  };
  </script>
  
  <style>
  .modal-header {
    border-bottom: none !important;
  }
  
  .modal-content {
    border: none !important;
    border-radius: 5px !important;
  }
  .input-code{
    width: 300px !important;
    padding: 20px !important;
  }
  </style>
  